// extracted by mini-css-extract-plugin
export default {"style2":"login_style2__QQqlG","style3":"login_style3__ONeMk","form":"login_form__HRezt","style4":"login_style4__PVtLN"};